import { NotStepInstance } from '../errors';

import Step from './Step';

class CompletedStep extends Step {
  constructor(step) {
    if (!(step instanceof Step)) {
      throw new NotStepInstance(`${step} is not an instance of ${Step}`);
    }

    super(step.name, step.completedURL, step.pendingURL);
  }

  get url() {
    return this._completedURL;
  }
}

export default CompletedStep;
